import { Box } from '@mui/material';

import JugadoresHeaderSection from './information/JugadoresHeaderSection';
import JugadoresTabsSection from './information/Tabs/JugadoresTabsSection';
import EstadisticasLaLigaFantasy from './information/EstadisticasLaLigaFantasy';
import ValorMercadoFantasyLaLiga from './information/ValorMercadoFantasyLaLiga';
import CoeficienteAnalitica from './information/CoeficienteAnalitica';
import ProximoPartido from './information/ProximoPartido';
import JugadoresConvocatoriaSeleccion from './JugadoresConvocatoriaSeleccion';
import FixturesNextLast from './FixturesNextLast';
import JugadorEventosPorPartido from './information/JugadorEventosPorPartido';
import JugadorPartidosGrid from './information/JugadorPartidosGrid';
import JugadoresGeneralStatus from './JugadoresGeneralStatus';
import Placement2Component from '../ads-components/placements/placement2';
import Placement6Component from '../ads-components/placements/placement6';

const JugadoresV2Component = ({ player, activeSubTab, slug }) => {
    return (
        <Box display={'flex'} flexDirection={'column'} alignItems={'center'} py={2}>
            <JugadoresHeaderSection player={player} />
            <JugadoresTabsSection activeTab={0} activeSubTab={activeSubTab} slug={slug} />
            <JugadoresGeneralStatus player={player} />
            <FixturesNextLast player={player} teamId={player?.team?.id ?? player?.teamId} />
            <Placement2Component />
            <JugadoresConvocatoriaSeleccion player={player} />
            <Box width={'100%'} display={'flex'} gap={2} flexDirection={{ xs: 'column-reverse', md: 'row' }}>
                <Box
                    width={{
                        xs: '100%',
                        md: '50%',
                        lg: '40%',
                    }}
                >
                    <JugadorPartidosGrid player={player} />
                </Box>
                <Box
                    display={'flex'}
                    flexDirection={{
                        xs: 'column',
                    }}
                    width={{
                        xs: '100%',
                        md: '50%',
                        lg: '60%',
                    }}
                    gap={1}
                >
                    <ProximoPartido player={player} slug={slug} />
                    <EstadisticasLaLigaFantasy player={player} slug={slug} />
                    <ValorMercadoFantasyLaLiga player={player} slug={slug} />
                    <CoeficienteAnalitica player={player} slug={slug} />
                </Box>
            </Box>

            <Placement6Component />

            <JugadorEventosPorPartido player={player} />
        </Box>
    );
};

export default JugadoresV2Component;
